import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';

function CustomTabTitle(props) {
  const { activeTabs, activeTab, onTabChange } = props;
  return (
    <div className="m-portlet__head">
      <div className="m-portlet__head-tools">
        <ul className="nav nav-tabs m-tabs-line">
          {activeTabs?.map(tab => (
            <button
              type="button"
              key={tab}
              className={`nav-link m-tabs__link ${
                tab?._id === activeTab ? 'active' : ''
              }`}
              onClick={() => onTabChange(tab._id)}
            >
              {tab.name}
            </button>
          ))}
        </ul>
      </div>
    </div>
  );
}

CustomTabTitle.propTypes = {
  activeTabs: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      content: PropTypes.string,
    }),
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default translate(CustomTabTitle);
